import http from "../../http-common";

const getAll = async () => {
  return await http
    .get("/ultimate/feature-audiences")
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const create = async (audience) => {
  return await http
    .post("/ultimate/feature-audiences", audience)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const update = async (audience) => {
  return await http
    .put(`/ultimate/feature-audiences/${audience.id}`, audience)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const remove = async (id) => {
  return await http
    .delete(`/ultimate/feature-audiences/${id}`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

export default { getAll, create, update, remove };
